<template>
  <el-form
    :model="userData.address"
    :rules="rules"
    ref="userAddressForm"
    label-position="top"
    autocomplete="off"
  >
    <el-row :gutter="24">
      <el-col
        :lg="12"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <el-form-item
          style="text-align: center"
          label="Driver License Front Side"
          prop="frontSide"
          v-if="typeof this.userData.address.frontSide !== 'undefined'"
        >
          <Uploader
            :base64.sync="userData.address.frontSide"
            @showLoader="showLoader"
            @imageUploaded="frontSideUploaded"
          />
        </el-form-item>
      </el-col>

      <el-col
        :lg="12"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <el-form-item
          style="text-align: center"
          label="Driver License Back Side"
          prop="backSide"
          v-if="typeof this.userData.address.backSide !== 'undefined'"
        >
          <Uploader
            :base64.sync="userData.address.backSide"
            @imageUploaded="backSideUploaded"
            @showLoader="showLoader"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item
      label="Street 1"
      prop="street1"
    >
      <el-input
        type="text"
        v-model="userData.address.street1"
      />
    </el-form-item>

    <el-form-item
      label="Street 2"
      prop="street2"
    >
      <el-input
        type="text"
        v-model="userData.address.street2"
      />
    </el-form-item>

    <el-form-item
      label="City"
      prop="city"
    >
      <el-input
        type="text"
        v-model="userData.address.city"
      />
    </el-form-item>

    <el-form-item
      label="Zip"
      prop="zip"
    >
      <the-mask
        v-model.number="userData.address.zip"
        mask="#####"
      />
    </el-form-item>

    <el-form-item
      label="State"
      prop="state"
    >
      <el-select
        v-model="userData.address.state"
        filterable
      >
        <el-option
          v-for="(state, key) in states"
          :key="key"
          :label="state"
          :value="state"
        />
      </el-select>
    </el-form-item>

    <el-form-item class="submit-btn">
      <el-button
        type="primary"
        @click="submitForm('userAddressForm')"
      >
        Save
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Uploader from '../form/Uploader';

export default {
  name: 'DriverLicense',
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    Uploader
  },
  data: () => {
    return {
      states: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],
      rules: {
        street1: [
          { required: true, message: 'Please input Street 1', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'Please input City', trigger: 'blur' }
        ],
        zip: [
          { required: true, message: 'Please input Zip', trigger: 'blur' }
        ],
        state: [
          { required: true, message: 'Please select State', trigger: 'change' }
        ],
        frontSide: [
          { required: true, message: 'Please upload Insurance Front Side image', trigger: 'change' }
        ],
        backSide: [
          { required: true, message: 'Please upload Insurance Back Side image', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    userData () {
      return this.user;
    }
  },
  created () {
    this.$axios('/Patient/GetPatientDriverLicenseImages', {
      method: 'GET',
      params: {
        patientNumber: this.userData.patientNumber
      }
    }).then((response) => {
      if (response.data.isSuccess) {
        if (response.data.data.length) {
          response.data.data.map((driverLicense) => {
            if (driverLicense.isFrontImage) {
              this.$set(this.userData.address, 'frontSide', 'data:image/png;base64,' + driverLicense.imageDataString);
            } else {
              this.$set(this.userData.address, 'backSide', 'data:image/png;base64,' + driverLicense.imageDataString);
            }
          });
        } else {
          this.$set(this.userData.address, 'frontSide', '');
          this.$set(this.userData.address, 'backSide', '');
        }
      } else {
        this.$message({
          showClose: true,
          message: 'Sorry! We could not get states!',
          type: 'warning'
        });
      }
    });
  },
  methods: {
    showLoader() {
      this.$emit('screenLoading', true);
    },
    frontSideUploaded () {
      this.$emit('screenLoading', true);
      this.$axios('/Ocr/driverlicense', {
        method: 'POST',
        data: {
          blobData: this.userData.address.frontSide.split(',')[1],
          state: this.userData.address.state
        }
      }).then((response) => {
        if (response.data.isSuccess && response.data.data.status === 'Success') {
          var address = {};
          response.data.data.fields.map((field) => {
            switch (field.name) {
              case 'ZipCode':
                Object.assign(address, { zip: field.value });
                break;
              case 'Street':
                Object.assign(address, { street1: field.value });
                break;
              case 'City':
                Object.assign(address, { city: field.value });
                break;
              case 'State':
                Object.assign(address, { state: field.value });
                break;
            }
          });
          Object.assign(this.userData.address, address);
          this.userData.address.ocrId = response.data.data.id;
        } else {
          this.$message({
            showClose: true,
            message: 'We could not recognize data from your driver license',
            type: 'warning'
          });
        }
        this.$emit('screenLoading', false);
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    backSideUploaded () {
      this.$emit('screenLoading', true);
      this.$axios('/Ocr/driverlicenseCode', {
        method: 'POST',
        data: {
          blobData: this.userData.address.backSide.split(',')[1]
        }
      }).then((response) => {
        if (response.data.isSuccess && response.data.data.status === 'Success') {
          var address = {};
          var fields = response.data.data.data;
          for (var field in fields) {
            switch (field) {
              case 'zipCode':
                Object.assign(address, { zip: fields[field] });
                break;
              case 'street':
                Object.assign(address, { street1: fields[field] });
                break;
              case 'city':
                Object.assign(address, { city: fields[field] });
                break;
              case 'state':
                Object.assign(address, { state: fields[field] });
                break;
            }
          }
          Object.assign(this.userData.address, address);
        } else {
          this.$message({
            showClose: true,
            message: 'We could not recognize data from your driver license',
            type: 'warning'
          });
        }
        this.$emit('screenLoading', false);
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveUserAddress();
        } else {
          return false;
        }
      });
    },
    saveUserAddress () {
      this.$emit('screenLoading', true);
      this.$axios('/Patient/UpdatePatientInfo', {
        method: 'PUT',
        data: Object.assign(this.userData.address, {
          patientNumber: this.userData.patientNumber,
          cellPhone: this.userData.cellPhone
        })
      }).then((response) => {
        if (response.data.isSuccess) {
          if (Object.prototype.hasOwnProperty.call(this.userData.address, 'ocrId') && this.userData.address.length) {
            this.saveCorrectedValue();
          }
          this.saveDriverLicenseFront().then((response) => {
            if (response.data.isSuccess) {
              this.saveDriverLicenseBack().then((response) => {
                if (response.data.isSuccess) {
                  this.saveStatisticData(this.getSessionId(), {driver_license_save: 'true'});
                  this.$emit('screenLoading', false);
                  this.$message({
                    showClose: true,
                    message: 'User data is saved!',
                    type: 'success'
                  });
                } else {
                  this.$emit('screenLoading', false);
                  this.$message({
                    showClose: true,
                    message: 'We could not save your driver license!',
                    type: 'warning'
                  });
                }
              });
            } else {
              this.$emit('screenLoading', false);
              this.$message({
                showClose: true,
                message: 'We could not save your driver license!',
                type: 'warning'
              });
            }
          });
        } else {
          this.$emit('screenLoading', false);
          this.$message({
            showClose: true,
            message: 'We could not save you data!',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenloading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    saveCorrectedValue () {
      return this.$axios('Ocr/RecognitionRequests/' + this.userData.address.ocrId + '/correctedValue', {
        method: 'PUT',
        data: {
          street1: this.userData.address.street1,
          street2: this.userData.address.street2,
          city: this.userData.address.city,
          zipCode: this.userData.address.zip,
          state: this.userData.address.state
        }
      });
    },
    saveDriverLicenseFront () {
      return this.$axios('/Patient/SavePatientDriverLicenseImage', {
        method: 'PUT',
        data: {
          patientNumber: this.userData.patientNumber,
          blobData: this.userData.address.frontSide.split(',')[1],
          isFrontImage: true
        }
      }).catch(() => {
        this.$emit('screenloading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    saveDriverLicenseBack () {
      return this.$axios('/Patient/SavePatientDriverLicenseImage', {
        method: 'PUT',
        data: {
          patientNumber: this.userData.patientNumber,
          blobData: this.userData.address.backSide.split(',')[1],
          isFrontImage: false
        }
      }).catch(() => {
        this.$emit('screenloading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
form::v-deep {

  label {
    padding: 0 !important;
  }

  .el-select {
    width: 100%;
  }
}
</style>
